import { ChangeDetectionStrategy, Component } from '@angular/core';

import { NavigationComponent, NavigationNode } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
    selector: 'dp-my-account',
    templateUrl: './my-account.component.html',
    styleUrl: './my-account.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DpMyAccountComponent extends NavigationComponent {
  myAccountNode$: Observable<NavigationNode | undefined> = this.service.getNavigationNode(this.componentData.data$);
}
